import React, { useState } from "react";
import API from "../api";
import { Link } from "react-router-dom";

function TrackOrder() {
  const [phone, setPhone] = useState("");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  // New state to track if we are showing full or masked data
  const [isMasked, setIsMasked] = useState(true);

const handleTrack = async (e) => {
    e.preventDefault();
    if (!phone || phone.length < 10) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);
    setError("");
    setOrder(null);

    try {
      const loggedInUser = JSON.parse(localStorage.getItem("user"));
      
      // 🚨 LOGIC FIX: Check if phone matches, then fetch by PHONE, not ID
      if (loggedInUser && loggedInUser.phone === phone) {
        
        // Use the new route we just made
        const res = await API.get(`/orders/mine/${phone}`);
        
        if (res.data && res.data.length > 0) {
          setOrder(res.data[0]); // Show the latest one
          setIsMasked(false);    // Show full details
        } else {
          setError("No orders found for this phone number.");
        }

      } else {
        // Guest / Different Number -> Use Masked Public Route
        const res = await API.get(`/orders/track/${phone}`);
        setOrder(res.data);
        setIsMasked(true);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError("No active order found for this number.");
    }
  };

  const steps = ["Pending", "Processing", "Shipped", "Delivered"];
  const currentStep = order ? steps.indexOf(order.status) : -1;

  return (
    <div style={pageContainer}>
      <div style={cardStyle}>
        <h2 style={titleStyle}>🚚 Track Your Order</h2>
        <p style={{ color: "#666", marginBottom: "20px" }}>
          Enter mobile number to check status.
        </p>

        {/* INPUT FORM */}
        <form onSubmit={handleTrack} style={searchBox}>
          <input
            type="tel"
            placeholder="e.g. 9876543210"
            value={phone}
            maxLength="10"
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
            style={inputStyle}
          />
          <button type="submit" style={trackBtn}>Track</button>
        </form>

        {loading && <div style={{ textAlign: "center", color: "#E65100", padding: 20 }}>Searching...</div>}
        {error && <p style={errorStyle}>{error}</p>}

        {order && (
          <div style={resultContainer}>
            
            {/* PRIVACY BADGE */}
            {!isMasked ? (
              <div style={{ ...privacyBadge, background: "#E8F5E9", color: "#2E7D32" }}>
                🔓 <strong>Verified Owner:</strong> Showing full details
              </div>
            ) : (
              <div style={{ ...privacyBadge, background: "#E3F2FD", color: "#0D47A1" }}>
                 🔒 <strong>Guest View:</strong> Personal details hidden
              </div>
            )}

            {/* ORDER HEADER */}
            <div style={orderHeader}>
              <div>
                <strong>Latest Order</strong>
                <div style={{ fontSize: "12px", color: "#888" }}>
                  {new Date(order.createdAt).toLocaleDateString("en-IN", {
                    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute:"2-digit"
                  })}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                 <div style={{ fontWeight: "bold", color: "#2E7D32", fontSize: "18px" }}>₹{order.total}</div>
                 <div style={{ fontSize: "11px", color: "#666" }}>
                   {/* Handle Item Count for both masked and unmasked objects */}
                   {isMasked ? order.itemCount : order.items.length} Items
                 </div>
              </div>
            </div>

            {/* 🚨 NEW: HANDLE CANCELLED STATUS SPECIFICALLY */}
    {order.status === "Cancelled" ? (
      <div style={{
        background: "#FFEBEE", 
        color: "#D32F2F", 
        padding: "20px", 
        borderRadius: "8px", 
        textAlign: "center", 
        fontWeight: "bold",
        border: "1px solid #FFCDD2",
        marginBottom: "20px"
      }}>
        ❌ This order has been cancelled.
      </div>
    ) : (
      /* ONLY SHOW TIMELINE IF ACTIVE */
      <div style={timelineContainer}>
        {steps.map((step, index) => {
          const isCompleted = index <= currentStep;
          const isActive = index === currentStep;
          return (
            <div key={step} style={stepWrapper}>
              <div style={{
                ...stepCircle,
                background: isCompleted ? "#2E7D32" : "#E0E0E0",
                border: isActive ? "4px solid #C8E6C9" : "none"
              }}>
                {isCompleted ? "✓" : index + 1}
              </div>
              {index < steps.length - 1 && (
                <div style={{
                  ...connectorLine,
                  background: index < currentStep ? "#2E7D32" : "#E0E0E0"
                }} />
              )}
              <span style={{ marginTop: "8px", fontSize: "12px", color: isCompleted ? "#333" : "#aaa" }}>
                {step}
              </span>
            </div>);})}</div>)}

            {/* CONDITIONAL DETAILS SECTION */}
            <div style={{ marginTop: "20px", background: "#f9f9f9", padding: "15px", borderRadius: "8px" }}>
              
              {/* 1. ADDRESS SECTION */}
              <p style={{ margin: "0 0 10px 0", fontSize: "13px", color: "#333" }}>
                <strong>Delivery Address:</strong><br/>
                <span style={{ color: isMasked ? "#999" : "#555" }}>
                   {isMasked ? "****** (Hidden for Privacy) ******" : order.address}
                </span>
              </p>

              {/* 2. ITEMS SECTION */}
              <div style={{ borderTop: "1px dashed #ddd", paddingTop: "10px" }}>
                <strong>Package Contents:</strong>
                
                {isMasked ? (
                  // MASKED VIEW
                  <p style={{ fontStyle: "italic", color: "#999", fontSize: "13px", margin: "5px 0" }}>
                    Login to view specific items.
                  </p>
                ) : (
                  // FULL VIEW
                  <ul style={{ paddingLeft: "20px", marginTop: "5px", color: "#555", fontSize: "13px" }}>
                    {order.items.map((item, i) => (
                      <li key={i}>
                        {item.name} <span style={{color: "#888"}}>x{item.quantity}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

            </div>

            {/* IF MASKED, SHOW LOGIN PROMPT */}
            {isMasked && (
              <div style={{ textAlign: "center", marginTop: "15px" }}>
                <Link to="/login" style={{ fontSize: "13px", color: "#F57C00", fontWeight: "bold" }}>
                  Are you {order.name.split(" ")[0]}? Login to view full details
                </Link>
              </div>
            )}

          </div>
        )}
      </div>
    </div>
  );
}

// ================= STYLES =================
const pageContainer = { display: "flex", justifyContent: "center", padding: "40px 20px", background: "#FAFAFA", minHeight: "80vh", fontFamily: "'Segoe UI', sans-serif" };
const cardStyle = { background: "#FFF", width: "100%", maxWidth: "500px", padding: "30px", borderRadius: "16px", boxShadow: "0 10px 30px rgba(0,0,0,0.05)", border: "1px solid #F0F0F0" };
const titleStyle = { color: "#333", margin: "0 0 10px 0", fontSize: "24px" };
const searchBox = { display: "flex", gap: "10px", marginBottom: "20px" };
const inputStyle = { flex: 1, padding: "12px", borderRadius: "8px", border: "1px solid #CCC", outline: "none", fontSize: "16px" };
const trackBtn = { background: "#F57C00", color: "#FFF", border: "none", padding: "0 25px", borderRadius: "8px", fontWeight: "bold", cursor: "pointer" };
const errorStyle = { color: "#D32F2F", background: "#FFEBEE", padding: "10px", borderRadius: "6px", fontSize: "14px", textAlign: "center" };
const resultContainer = { marginTop: "20px", animation: "fadeIn 0.5s ease" };
const privacyBadge = { padding: "8px", borderRadius: "6px", fontSize: "12px", marginBottom: "15px", textAlign: "center" };
const orderHeader = { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "25px", paddingBottom: "15px", borderBottom: "1px solid #eee" };
const timelineContainer = { display: "flex", justifyContent: "space-between", position: "relative", marginBottom: "20px" };
const stepWrapper = { display: "flex", flexDirection: "column", alignItems: "center", position: "relative", flex: 1 };
const stepCircle = { width: "30px", height: "30px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "#FFF", fontSize: "14px", fontWeight: "bold", zIndex: 2 };
const connectorLine = { position: "absolute", top: "15px", left: "50%", width: "100%", height: "3px", zIndex: 1 };

export default TrackOrder;